// Utility functions for va-order-test

export function parseJson(str, defaultObj = {}) {
  try {
    let JsonObj = JSON.parse(str);
    return JsonObj ? JsonObj : defaultObj;
  } catch (e) {
    return defaultObj;
  }
}

export function getRedirectUrl(redirectPage) {
  // Simple redirect function - can be expanded later
  const baseUrl = window.location.origin;
  switch(redirectPage) {
    case "loginPage":
      return `${baseUrl}/login`;
    default:
      return baseUrl;
  }
}